import { render } from "./Hinges.vue?vue&type=template&id=9abeb350&scoped=true"
import script from "./Hinges.vue?vue&type=script&lang=js"
export * from "./Hinges.vue?vue&type=script&lang=js"

import "./Hinges.vue?vue&type=style&index=0&id=9abeb350&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9abeb350"]])

export default __exports__